export default "__VITE_ASSET__DATuup0T__"